module.exports = __webpack_public_path__ + "static/img/durian.bbcd4c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/durian.png
// module id = UdQV
// module chunks = 1